<template>
  <div class="mobile-header" :class="{ 'with-border': showBorder, 'with-shadow': showShadow }">
    <div class="header-content">
      <!-- Title Section -->
      <div class="title-section">
        <h1 class="page-title">
          <IonIcon v-if="icon" :icon="icon" class="title-icon" />
          {{ title }}
        </h1>
        <p v-if="subtitle" class="page-subtitle">{{ subtitle }}</p>
      </div>

      <!-- Actions Section -->
      <div v-if="$slots.actions" class="header-actions">
        <slot name="actions" />
      </div>
    </div>

    <!-- Secondary Content (breadcrumbs, filters, etc.) -->
    <div v-if="$slots.secondary" class="header-secondary">
      <slot name="secondary" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { IonIcon } from '@ionic/vue';

interface Props {
  title: string;
  subtitle?: string;
  icon?: string;
  showBorder?: boolean;
  showShadow?: boolean;
}

defineProps<Props>();
</script>

<style scoped>
.mobile-header {
  width: 100%;
  background: var(--ion-background-color);
  padding: 1rem 1rem 0.75rem 1rem;
  position: sticky;
  top: 0;
  z-index: 30;
}

.mobile-header.with-border {
  border-bottom: 1px solid var(--ion-input-border-color);
}

.mobile-header.with-shadow {
  box-shadow: var(--ion-box-shadow);
}

.header-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.title-section {
  min-width: 0;
  flex: 1;
}

.page-title {
  margin: 0 0 0.25rem 0;
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--ion-text-color-primary);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.title-icon {
  font-size: 1.25rem;
  color: var(--ion-color-primary);
  flex-shrink: 0;
}

.page-subtitle {
  margin: 0;
  font-size: 0.75rem;
  color: var(--ion-text-color-secondary);
  font-weight: 400;
  line-height: 1.3;
}

.header-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  align-items: center;
  flex-shrink: 0;
}

.header-secondary {
  padding-top: 0.75rem;
  margin-top: 0.25rem;
}
</style>
